import axios from 'axios'
import router from './router'

// 创建 axios 实例
const service = axios.create({
    // baseURL = 'http://121.196.11.162:7002/',
    baseURL: 'https://api.wzyjz.cn/',
    //   baseURL: 'http://localhost:7002/', 
    timeout: 5000 // 请求超时设置
})

// 请求拦截器
service.interceptors.request.use(config => {
    const token = sessionStorage.getItem('token')
    if (token) {
        config.headers['X-token'] = token // 在请求头中添加 token
    }
    return config
}, error => {
    return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(response => {
    response.headers['Access-Control-Allow-Origin'] = '*'
    return response
}, error => {
    if (error.response && error.response.status === 402) {
        router.push('/Login') // 遇到 402 状态码时跳转到登录页面
    }
    return Promise.reject(error)
})

export default service
